/** Layout shell — arquitetura atual (GameShell / AppPage). */
export const LAYOUT_IDS = {
  shell: 'layout-shell',
  topbar: 'layout-topbar',
  main: 'layout-main',
  bottomNav: 'layout-bottom-nav'
} as const

/**
 * IDs do Toolbar legado — somente `page/Toolbar.tsx` (@deprecated).
 * Não usar em PageHeader, PageScrollLayout ou features novas.
 */
export const LEGACY_TOOLBAR_IDS = {
  root: 'legacy-toolbar',
  sentinel: 'legacy-toolbar-sentinel'
} as const

/** @deprecated Renomeado de `ttz_app_body` — raiz do documento (html). */
export const APP_ROOT_ID = 'app-root'
